import { render, staticRenderFns } from "./parnterList.vue?vue&type=template&id=32e0629a&scoped=true&"
import script from "./parnterList.vue?vue&type=script&lang=js&"
export * from "./parnterList.vue?vue&type=script&lang=js&"
import style0 from "./parnterList.vue?vue&type=style&index=0&id=32e0629a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e0629a",
  null
  
)

export default component.exports